export default {
  black: "#222",
  blackLight: "#353535",
  border: "#ccc",
  green: "#61a901",
  grey: "#9d9d9d",
  white: "#fafafa",
}
